export default __webpack_public_path__ + "static/ds_05-ff325d2c4b3125ae993229ceb44e5fa4.png";